export default "__VITE_ASSET__317fef58__"